import { LinkProps, RedirectProps, useLocation } from "react-router-dom";

export function usePropsToWithUTM<T extends LinkProps | RedirectProps>(
  props: T
): T {
  const location = useLocation();
  const existingParams = new URLSearchParams(location.search);

  if (typeof props.to === "string") {
    let to = props.to;
    for (const [key, value] of existingParams) {
      if (key.startsWith("utm_")) {
        to += `${to.includes("?") ? "&" : "?"}${key}=${value}`;
      }
    }

    return { ...props, to };
  } else if (typeof props.to === "object") {
    const newParams = new URLSearchParams(props.to.search);
    for (const [key, value] of existingParams) {
      if (key.startsWith("utm_") && !newParams.has(value)) {
        newParams.append(key, value);
      }
    }

    return {
      ...props,
      to: {
        ...props.to,
        search: newParams.toString(),
      },
    };
  } else {
    return props;
  }
}
